import { render, staticRenderFns } from "./ApiForm.vue?vue&type=template&id=2ad4c796&"
import script from "./ApiForm.vue?vue&type=script&lang=ts&"
export * from "./ApiForm.vue?vue&type=script&lang=ts&"
import style0 from "./ApiForm.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports